import { DesignHeader } from "../DesignHeader";
import { DesignSideNav } from "../DesignSideNav";
import ExamEdit from "../../exam/ExamEdit";
import { ApiExamApi, ApiExamQuestionApi } from "../../../generated/api";
import type { ExamPreviewPlayerProps } from "../../exam/ExamPreviewPlayer";

type Exam = Awaited<ReturnType<ApiExamApi["apiVideoVideoIdExamGet"]>>;
type ExamQuestion = Awaited<
  ReturnType<ApiExamQuestionApi["apiVideoVideoIdExamQuestionsGet"]>
>[number];

export interface DesignExamEditProps {
  csrfToken: string;
  designHashId: string;
  designId: number;
  videoId: number;
  folderHashId: string;
  shareUrl: string;
  embedHtml: string;
  domainWatchLinkAvailable: boolean;
  videoHashId: string;
  exam: Exam;
  examQuestions: ExamQuestion[];

  // 生成AI機能まわりの制御フラグ
  generatingJobState?: "init" | "processing" | "failed" | "completed";
  genaiEnabled?: boolean;

  // プレビュー再生周りのprops
  video?: ExamPreviewPlayerProps;
}

export function DesignExamEdit(props: DesignExamEditProps) {
  return (
    <div className="p-design">
      <DesignHeader
        csrfToken={props.csrfToken}
        videoId={props.videoId}
        designId={props.designId}
        folderHashId={props.folderHashId}
        videoShareUrl={props.shareUrl}
        videoEmbedHtml={props.embedHtml}
        domainWatchLinkAvailable={props.domainWatchLinkAvailable}
      />

      <div className="p-design__main">
        <DesignSideNav designHashId={props.designHashId} mode="exam" />
        {/* メインエリア */}
        <div className="p-design__main--content-full-width">
          <ExamEdit
            csrfToken={props.csrfToken}
            videoId={props.videoId}
            videoHashId={props.videoHashId}
            exam={props.exam}
            examQuestions={props.examQuestions}
            generatingJobState={props.generatingJobState}
            genaiEnabled={props.genaiEnabled}
            video={props.video}
          />
        </div>
      </div>
    </div>
  );
}
